import { AutoMap } from '@automapper/classes';

export class MeasureEauEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingTime!: string;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    SamplingID!: number;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    TakeAnotherDay!: boolean;
    @AutoMap()
    ReferenceEtiquette?: string
    @AutoMap()
    Position!: number;
    MaterielEauId?: number;
}
